module.exports = __webpack_public_path__ + "img/icon_bars.456a8479.svg";